module.exports = __webpack_public_path__ + "static/media/online-occupational-therapy.5ef1a436.jpg";